export default function LeadPricing() {
  const pricingTiers = [
    {
      category: 'General Services',
      price: '$10-$25',
      icon: 'ri-tools-line',
      examples: ['Handyman', 'Cleaning', 'Landscaping', 'Pet Services'],
      color: 'from-blue-500 to-blue-600'
    },
    {
      category: 'Professional Services',
      price: '$25-$50',
      icon: 'ri-briefcase-line',
      examples: ['Legal', 'Accounting', 'Real Estate', 'Insurance'],
      color: 'from-purple-500 to-purple-600'
    },
    {
      category: 'Home Services',
      price: '$50-$100',
      icon: 'ri-home-gear-line',
      examples: ['HVAC', 'Plumbing', 'Electrical', 'Roofing', 'Solar'],
      color: 'from-emerald-500 to-emerald-600'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <div className="inline-block bg-emerald-100 text-emerald-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            For Service Providers
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Pay-Per-Lead Pricing
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Only pay for qualified leads you want to pursue. No monthly fees, no contracts.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {pricingTiers.map((tier) => (
            <div key={tier.category} className="bg-white border-2 border-gray-200 rounded-xl p-8 hover:border-emerald-500 hover:shadow-lg transition-all">
              <div className={`w-16 h-16 bg-gradient-to-br ${tier.color} rounded-xl flex items-center justify-center mb-4`}>
                <i className={`${tier.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">
                {tier.category}
              </h3>
              <div className="text-3xl font-bold text-emerald-500 mb-4">
                {tier.price}
                <span className="text-lg text-gray-600 font-normal"> per lead</span>
              </div>
              <div className="space-y-2 mb-6">
                {tier.examples.map((example) => (
                  <div key={example} className="flex items-center gap-2 text-gray-600">
                    <i className="ri-check-line text-emerald-500"></i>
                    <span>{example}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-2xl p-8">
          <div className="grid md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="w-12 h-12 bg-emerald-500 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-shield-check-line text-2xl text-white"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">Verified Leads Only</h4>
              <p className="text-sm text-gray-600">All leads are verified with contact information and project details</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 bg-emerald-500 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-notification-3-line text-2xl text-white"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">Instant Notifications</h4>
              <p className="text-sm text-gray-600">Get notified immediately when a new lead matches your services</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 bg-emerald-500 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-line-chart-line text-2xl text-white"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">Performance Analytics</h4>
              <p className="text-sm text-gray-600">Track your lead conversion rates and ROI with detailed analytics</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}